<template>
  <div>
    <div style="background-color: white; padding: 15px;">
      <div style="padding-bottom: 15px; border-bottom: 1px solid #e7e7e7">
        <span style="font-size: 13px; color:#97a8be">首页 / 系统设置 / 系统配置 / 添加配置</span>
      </div>
      <div style="padding-top: 15px;">
        <table width="100%">
          <tr>
            <td class="leftTd">
              <span style="color: red">* </span>主键
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="key" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              <span style="color: red">* </span>配置项
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="name" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              <span style="color: red">* </span>配置信息
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="value" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              配置说明
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <textarea v-model="note" class="boxText" style="height: 180px;width: 80%; padding-top: 15px;"></textarea>
            </td>
          </tr>

        </table>
      </div>

      <div style="padding-top: 15px; padding-left: 150px">
        <input @click="addAdmin" type="button" style="cursor: pointer; padding: 10px 25px; border-radius: 3px; background-color: #1890ff; border: 1px solid #1890ff; color: white" value="添加" />
        <input @click="goback" type="button" style="cursor: pointer; padding: 10px 25px; border-radius: 3px; background-color: #ffffff; border: 1px solid #dbdbdb; margin-left: 15px; color: #606266" value="返回" />
      </div>
    </div>

  </div>
</template>

<script>

import {closeLoading, DO_NET_URL, loading, toask} from "@/config/config";
import {axiosGet, axiosPost, axiosPostJson} from "@/main";

export default {
  name: "AddSystemConfig",
  data(){
    return{
      key:"",
      name:"",
      value:"",
      note:""
    }
  },
  mounted(){
    let that=this
    if(localStorage.getItem("iwa_token")==null||localStorage.getItem("iwa_token")==""){
      setTimeout(function (){
        that.$router.replace('index')
      },600);
    }
  },
  methods: {
    addAdmin(){
      let that=this
      if(this.key==""){
        toask("请输入主键！",6)
        return
      }
      if(this.name==""){
        toask("请输入配置项！",6)
        return
      }
      if(this.value==""){
        toask("请输入配置信息！",6)
        return
      }
      loading("请求中")
      axiosPost(DO_NET_URL+"SystemConfig/AddSystemConfig?key="+this.key+"&name="+this.name+"&value="+this.value+"&note="+this.note,"",function (res){
        closeLoading()
        if(res.code==200){
          toask("添加成功",6)
          setTimeout(function (){
            that.$emit("send",'systemConfig')
          },600)
        }else{
          toask(res.data,6)
        }
      })
    },
    goback(){
      this.$emit("send",'systemConfig')
    },

  }
}
</script>

<style scoped>
.boxText{-webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: 12px;
  height: 40px;
  /*line-height: 40px;*/
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  width: 50%;}
.leftTd{text-align: right;
  vertical-align: middle;
  font-size: 12px;
  color: #606266;
  line-height: 40px;
  padding: 15px 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;font-weight: 700; width: 120px}
.addBtn{color: #1890ff;background: #e8f4ff; border: 1px solid #1890ff; cursor: pointer; float: left; font-size: 12px;padding: 7px 15px;border-radius: 3px;}
.th{border-bottom:1px solid #dfe6ec; text-align: left; padding:0 10px;word-break: break-word;background-color: #f8f8f9;color: #515a6e;height: 40px;font-size: 12px;}
.td{border-bottom:1px solid #dfe6ec;padding:0 10px; word-break:break-word;background-color: #ffffff;color: #606266;height: 40px;font-size: 12px;}
</style>